module.exports = __webpack_public_path__ + "static/media/22871a48-5aa6-4f83-8e98-dd2efb6823c6.6759d5c7.webp";